'use client';

import React, { useEffect, useRef } from 'react';

const timeline = [
  {
    year: '2026',
    title: 'Prathaa — প্রথা',
    desc: 'Gala Evening moves to Shanmukhananda Chandrasekhara Saraswati Auditorium for the first time ever. Javed Ali headlines. 1,000 memberships targeted. Our biggest, most ambitious chapter.',
    icon: '✦',
    current: true,
  },
  {
    year: '2025',
    title: 'Patachitra — পটচিত্র',
    desc: 'Inaugurated by Maharaj, Ramakrishna Mission Mumbai. 450 members. 2,000 sit-down Bhog plates. Chandrabindoo and Rituparna Sengupta grace the stage.',
    icon: '🎨',
  },
  {
    year: '2024',
    title: 'Thakur Dalaan — ঠাকুর দালান',
    desc: 'Inaugurated by His Grace Gauranga Das, ISKCON. 1,000+ sit-down Bhog plates. Warm, intimate, deeply personal — our first themed Puja.',
    icon: '🙏',
  },
  {
    year: '2023',
    title: 'First Durga Puja',
    desc: 'HCAF holds its inaugural Durga Puja in South-Central Mumbai. The response from the community is immediate and overwhelming.',
    icon: '🪔',
  },
  {
    year: '2022',
    title: 'HCAF Founded',
    desc: 'A group of like-minded Mumbai families come together for a simple, soulful Saraswati Puja — the seed of what would become HCAF.',
    icon: '🌱',
  },
];

export default function TimelineSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => { entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('active'); }); },
      { threshold: 0.06 }
    );
    sectionRef?.current?.querySelectorAll('.reveal')?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-dark-bg noise-overlay w-full px-4 md:px-12 pt-14 md:pt-20 pb-12 md:pb-16">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14 reveal">
          <span className="inline-block px-4 py-1.5 rounded-full border border-accent/30 text-accent text-xs font-bold tracking-widest uppercase mb-4 md:mb-5">
            The Journey
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-black text-white tracking-tight">
            Five Years of <span className="text-accent">Anondo</span>
          </h2>
        </div>

        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-6 top-0 bottom-0 w-px bg-gradient-to-b from-accent/40 via-accent/20 to-transparent hidden md:block" />

          <div className="flex flex-col gap-6 md:gap-8">
            {timeline?.map((item, i) => (
              <div
                key={item?.year}
                className={`reveal flex gap-4 md:gap-6 items-start ${item?.current ? 'opacity-100' : ''}`}
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                {/* Dot */}
                <div className={`relative z-10 flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center text-lg md:text-xl hidden md:flex ${item?.current ? 'bg-primary animate-pulse-glow' : 'bg-dark-card border border-accent/20'}`}>
                  {item?.icon}
                </div>

                {/* Content */}
                <div className={`flex-1 bg-dark-card border rounded-2xl md:rounded-3xl p-5 md:p-6 ${item?.current ? 'border-primary/40 bg-primary/5' : 'border-accent/10'}`}>
                  <div className="flex items-center gap-2 md:gap-3 mb-2">
                    <span className="font-display text-2xl md:text-3xl font-black text-accent">{item?.year}</span>
                    {item?.current && (
                      <span className="px-2 md:px-3 py-0.5 rounded-full bg-primary text-primary-foreground text-xs font-bold tracking-widest uppercase">
                        Current
                      </span>
                    )}
                  </div>
                  <h3 className="font-display text-lg md:text-xl font-black text-white tracking-tight mb-2">{item?.title}</h3>
                  <p className="text-white/60 text-sm leading-relaxed">{item?.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}